//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    src: { type: String, default: '/img/blog.jpg' },
    title: { type: String, required: true },
    summary: { type: String, default: null },
    credit: {
      type: Object,
      default: () => ({
        by: {
          text: 'Patrick Fore',
          href:
            'https://unsplash.com/@patrickian4?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText',
        },
        on: {
          text: 'Unsplash',
          href:
            'https://unsplash.com/s/photos/blog?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText',
        },
      }),
    },
  },
};
